import React, { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination } from "swiper/modules";
import { db, auth, storage } from "../../firebaseConfig"; // Firebase bağlantısı
import { collection, onSnapshot, updateDoc, doc } from "firebase/firestore"; // onSnapshot eklendi
import { ref, uploadBytes, getDownloadURL } from "firebase/storage"; // Storage işlemleri
import toast from "react-hot-toast";

function Anaicerik() {
  const [slides, setSlides] = useState([]);
  const [activeSlide, setActiveSlide] = useState(null);
  const [image, setImage] = useState(null);
  const [preview, setPreview] = useState(null);
  const [isDragging, setIsDragging] = useState(false);
  const [userClaims, setUserClaims] = useState(null);
  const [loading, setLoading] = useState(true);
  const [inputValue, setInputValue] = useState(activeSlide?.title || "");

  // Kullanıcı yetkilerini kontrol et
  useEffect(() => {
    const checkUserClaims = async () => {
      try {
        const user = auth.currentUser;
        if (!user) {
          toast.error("Kullanıcı oturum açmamış. Yönlendiriliyorsunuz...");
          setTimeout(() => {
            window.location.href = "/login";
          }, 3000);
          return;
        }
        const idTokenResult = await user.getIdTokenResult();
        const claims = idTokenResult.claims;
        setUserClaims(claims);
      } catch (error) {
        console.error("Yetki kontrolü yapılırken hata oluştu:", error);
        toast.error("Yetki kontrolü başarısız.");
      } finally {
        setLoading(false);
      }
    };

    checkUserClaims();
  }, []);

  // Firestore'dan slider verilerini gerçek zamanlı izleme
  useEffect(() => {
    const unsubscribe = onSnapshot(
      collection(db, "buyuksehir_ustslider"),
      (snapshot) => {
        const sliderData = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setSlides(sliderData);
        if (!activeSlide) setActiveSlide(sliderData[0]);
      },
      (error) => {
        console.error("Veriler gerçek zamanlı izlenirken hata oluştu:", error);
        toast.error("Veriler izlenirken hata oluştu.");
      }
    );

    return () => unsubscribe(); // Bileşen unmount olduğunda dinleyiciyi kapat
  }, [activeSlide]);

  // Görsel Yükleme ve Güncelleme
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      if (!file.type.startsWith("image/")) {
        toast.error("Lütfen geçerli bir görsel dosyası seçin.");
        return;
      }
      setImage(file);
      setPreview(URL.createObjectURL(file));
    } else {
      toast.error("Dosya seçilmedi.");
    }
  };

  const handleUpdateSlide = async () => {
    if (!userClaims?.is_admin && !userClaims?.is_editor) {
      toast.error("Bu işlemi yapmak için yetkiniz yok.");
      return;
    }

    if (!image || !activeSlide?.id) {
      toast.error("Lütfen bir görsel seçin ve slider belirleyin.");
      return;
    }

    try {
      // Storage'a dosya yükleme
      const storageRef = ref(storage, `slider-images/${String(activeSlide.id)}-${image.name}`);
      await uploadBytes(storageRef, image);
      const downloadURL = await getDownloadURL(storageRef);

      // Firestore dokümanını güncelleme
      const slideDocRef = doc(db, "buyuksehir_ustslider", activeSlide.id);

      await updateDoc(slideDocRef, {
        img: downloadURL, // Sadece img alanını güncelle
      });

      toast.success("Slider başarıyla güncellendi.");
      setImage(null);
      setPreview(null);
    } catch (error) {
      console.error("Görsel güncellenirken hata oluştu:", error);
      toast.error("Görsel güncellenirken hata oluştu.");
    }
  };

  // Drag-and-Drop İşlemleri
  const handleDrop = async (event) => {
    if (!userClaims?.is_admin && !userClaims?.is_editor) {
      toast.error("Bu işlemi yapmak için yetkiniz yok.");
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    const file = event.dataTransfer.files[0];
    if (file) {
      setImage(file);
      setPreview(URL.createObjectURL(file));
    }
    setIsDragging(false);
  };

  const handleDragOver = (event) => {
    event.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = () => {
    setIsDragging(false);
  };

  const handleReset = () => {
    if (!userClaims?.is_admin && !userClaims?.is_editor) {
      toast.error("Bu işlemi yapmak için yetkiniz yok.");
      return;
    }

    setImage(null);
    setPreview(null);
  };

  useEffect(() => {
    setInputValue(activeSlide?.title || "");
  }, [activeSlide]);

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-indigo-500"></div>
      </div>
    );
  }

  if (!userClaims?.is_admin && !userClaims?.is_editor) {
    return (
      <div className="flex items-center justify-center h-screen">
        <h1 className="text-2xl font-bold text-red-500">Bu sayfaya erişim izniniz yok.</h1>
      </div>
    );
  }

  return (
    <div
    className="grid grid-cols-12 overflow-y-scroll scrollbar-thin scrollbar-thumb-gray-500 scrollbar-track-gray-300 rounded shadow"
    style={{
      height:
        window.innerWidth <= 768
          ? 710
          : window.innerWidth <= 900
          ? 700
          : 750,
      overflowY: "scroll",
      
    }}
  >
      <div className="col-span-12 md:col-span-7 p-6 flex flex-col justify-center bg-sky-100">
        <h1 className="text-2xl font-bold mb-6">Ana içerik oluştur</h1>
        <div className="space-y-4">
          <span>Başlığı:</span>
          <input
            type="text"
            className="w-full p-2 border border-gray-300 rounded-lg"
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
          />
          {preview && (
            <div className="relative">
              <img
                src={preview}
                alt="Preview"
                className="w-full h-48 object-cover rounded-md mb-4"
              />
              <button
                className="absolute top-2 right-2 bg-red-500 text-white px-3 py-1 rounded-full"
                onClick={handleReset}
              >
                Reset
              </button>
            </div>
          )}
          
          <label
            htmlFor="fileInput"
            className={`w-full h-20 border-2 border-dashed flex items-center bg-white justify-center rounded-md cursor-pointer hover:bg-gray-100 ${
              isDragging ? "bg-gray-100 opacity-75" : ""
            }`}
            onDrop={handleDrop}
            onDragOver={handleDragOver}
            onDragLeave={handleDragLeave}
          >
            <span className="text-gray-500">
              {isDragging ? "Bırakınız..." : "Görsel yüklemek için tıklayın veya sürükleyin"}
            </span>
            <input
              id="fileInput"
              type="file"
              accept="image/*"
              onChange={handleFileChange}
              className="hidden"
            />
          </label>
        </div>
        <button
          className="bg-sky-600 text-white py-2 mt-5 border border-gray-300 rounded-md transition duration-300 shadow-lg hover:bg-sky-700 active:bg-sky-800"
          onClick={handleUpdateSlide}
        >
          Güncelle
        </button>
      </div>

      <div className="col-span-12 md:col-span-5 flex flex-col items-center justify-center bg-gray-200">
        <h1 className="text-center text-xl font-bold mb-4">Mobil Görünüm</h1>
        <div className="relative bg-black rounded-[50px] overflow-hidden border-8 border-black shadow-lg w-[90%] md:w-[50%] aspect-[9/16]">
          <div className="absolute top-0 left-1/2 transform -translate-x-1/2 w-[15%] h-4 bg-black rounded-b-[20px] z-10"></div>
          <div className="absolute inset-0 bg-white rounded-[45px] p-1 pt-10">
            <Swiper
              modules={[Pagination]}
              spaceBetween={20}
              slidesPerView={1}
              pagination={{ clickable: true }}
              onSlideChange={(swiper) =>
                setActiveSlide(slides[swiper.activeIndex])
              }
            >
              {slides.map((slide) => (
                <SwiperSlide key={slide.id}>
                  <div className="flex flex-col items-center justify-center h-full">
                    <img
                      src={slide.img}
                      alt={slide.title}
                      className="w-full h-40 object-cover rounded-lg mb-4"
                    />
                    <h2 className="text-lg font-bold">{slide.title}</h2>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          <div>
            <span style={{
              padding:5,
              position: "relative",
              top:40
            }}>
              Sayfanın, ana içerik kısmıdır! <br></br>
              Önerilen, görsel boyutları, 1920x400'dır.
            </span>
          </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Anaicerik;
